import BillingAddress from "./BillingAddress";
import ContactPerson from "./ContactPerson";
import AboCard from "./AboCard";
import CustomerService from "./CustomerService";
import YourAdvantages from "./YourAdvantages";
import {Button} from "@mui/material";
import {useState} from "react";
import store from "../store";
import {connect} from "react-redux";
import {validateField} from "../utils/helpers";
import {useEffect} from "react";
import {useLocation, useSearchParams} from "react-router-dom";

export default connect(
  ({
    // to use redux states here
    i18n,
    isLoading,
    orderSubscription,
  }) => ({
    i18n,
    isLoading,
    orderSubscription,
  }),
  {
    // redux functions
  }
)((props, {}) => {
  const validateForm = () => {
    return (
      validateField(props.orderSubscription.companyName) ||
      validateField(props.orderSubscription.streetHouseNumber) ||
      validateField(props.orderSubscription.zipCode) ||
      validateField(props.orderSubscription.city) ||
      validateField(props.orderSubscription.firstName) ||
      validateField(props.orderSubscription.email) ||
      validateField(props.orderSubscription?.country?.value) ||
      validateField(props.orderSubscription.lastName)
    );
  };
  const location = useLocation();

  // const [searchParams] = useSearchParams();
  // const isMobile = searchParams.get("isMobile") === "true";
  const queryParams = new URLSearchParams(window.location.search);
  const isMobile = queryParams.get("isMobile");
  // const isMobile = true;
  console.log("mobile:" + isMobile);
  useEffect(() => {
    if (isMobile) {
      console.log("Order subscription completed. Returning to mobile app.");
      // // Redirect to mobile app using deep link
      // window.location.href = "myapp://return"; // Replace with actual deep link
    }
  }, [isMobile]);
  return (
    <>
      <div className="step-content">
        <div className="wrapper">
          <div className="column-left">
            <BillingAddress />
            <ContactPerson />
            <Button
              className="stepper-btn"
              variant="contained"
              onClick={props.onClickNext}
              disabled={validateForm()}
            >
              Nächster Schritt
            </Button>
          </div>
          <div className="column-right hide-on-mobile">
            <AboCard />
            <CustomerService />
            <YourAdvantages />
          </div>
        </div>
      </div>
    </>
  );
});
